import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import type { Environment } from '@environments/environment.types';

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  private config: Environment = environment;

  setConfig(config: Environment): void {
    this.config = config;
  }

  get env(): Environment {
    return this.config;
  }
}
